"use client";

import dynamic from "next/dynamic";
import type { Variants } from "framer-motion"; 

// wrapper สำหรับ motion.div
export const MotionDiv = dynamic(
  () => import("framer-motion").then((mod) => mod.motion.div),
  { ssr: false }
);

// wrapper สำหรับ motion.section
export const MotionSection = dynamic(
  () => import("framer-motion").then((mod) => mod.motion.section),
  { ssr: false }
);

// wrapper สำหรับ motion.form (ถ้าใช้)
export const MotionForm = dynamic(
  () => import("framer-motion").then((mod) => mod.motion.form),
  { ssr: false }
);

export type { Variants }; 

